<template>
  <v-card flat tile class="d-flex flex-column folders-tree-card" ma-1>
    <v-card-title class="folderLevelTitle">Folder Level</v-card-title>
    <v-divider color="black"></v-divider>
    <v-treeview
      :items="getFolderStructure"
      :open="open"
      :active="active"
      activatable
      hoverable
      selection-type="independent"
      style="cursor: pointer;"
      @update:active="folderClicked"
    >
      <template v-slot:prepend="{item, open}">
        <v-icon v-if="item">{{ getFolderIcon(open) }}</v-icon>
      </template>
    </v-treeview>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { eventBus } from "@/main";

export default {
  name: "ExplorerTree",
  data() {
    return {
      open: [],
      active: []
    };
  },
  created() {
    eventBus.$on("homeClicked", () => {
      this.open = [];
      this.active = [];
    });
  },
  computed: {
    ...mapGetters(["getFolderStructure"])
  },
  methods: {
    ...mapActions(["updateActiveFolder", "clearActiveFolder"]),
    folderClicked(activeFolder) {
      if (activeFolder.length !== 0) {
        this.updateActiveFolder(activeFolder[0]);
      } else {
        this.clearActiveFolder();
      }
    },
    getFolderIcon(open) {
      if (open) {
        return "mdi-folder-open";
      }
      return "mdi-folder";
    }
  }
};
</script>

<style lang="scss" scoped>
.folders-tree-card {
  height: 100%;
  .scroll-x {
    overflow-x: auto;
  }
  ::v-deep .folders-tree {
    width: fit-content;
    min-width: 250px;
    .v-treeview-node {
      cursor: pointer;
      &:hover {
        background-color: rgba(0, 0, 0, 0.02);
      }
    }
  }
}
.folderLevelTitle {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>